import React from 'react'
import { useParams } from 'react-router-dom'
import apiService from 'services/api'
import CommonPage from 'components/DataExpansionComponents/Common/CommonPage'
import { ContactCompanyType } from 'models/contact_companies'
import { usePreferences } from 'context/preferences/PreferencesContext'
import { featureFlagService } from 'utils/featureFlagService'
import { NewLodgingLocationPage } from '../new-company-pages/NewLodgingLocationPage'

export default function LodgingDoorPage() {
  const { enableNewCompanyPage, isLoading } = featureFlagService()
  const urlParams = useParams()
  const lodgingID = urlParams.lodging_id!

  if (enableNewCompanyPage) {
    return (
      <NewLodgingLocationPage
        lodgingID={parseInt(lodgingID)}
        isLoading={isLoading}
      />
    )
  }

  return (
    <_LodgingDoorPage lodgingID={parseInt(lodgingID)} isLoading={isLoading} />
  )
}

function _LodgingDoorPage({
  lodgingID,
  isLoading: isExternalLoading,
}: {
  lodgingID: number
  isLoading: boolean
}) {
  const { preferences } = usePreferences()

  const api = apiService()
  const {
    data,
    isLoading: isLodgingLoading,
    isError,
    error,
  } = api.useGetLodgingDoor(lodgingID)

  const isLoading = isExternalLoading || isLodgingLoading

  return (
    <CommonPage
      uniqueCompanyTypeId={lodgingID}
      useGetCompany={{
        companyData: data,
        contactCompanyData: data?.chain_proxy,
        isLoading,
        isError,
        error,
      }}
      tableTypeSlug="lodging-hospitality-doors"
      companyTypeSlug="lodging-hospitality"
      breadcrumbs={[
        {
          title: 'Chain',
          breadcrumb: data?.lodging?.name,
          url: `/lodging/chain/${preferences?.company_type_prefix_map[ContactCompanyType.Lodging]}${data?.lodging?.chain_id}`,
        },
      ]}
      getFieldsFromData={(data) => {
        return {
          contactCompanyId: data?.chain_proxy.id,
          companyName: data?.lodging?.name,
          websiteAddress: data?.lodging?.website,
          phone: data?.lodging?.phone,
          doorProxyId: data?.id,
          address: {
            addressInfo: {
              fullAddress: data?.lodging?.address,
              city: data?.lodging?.city,
              state: data?.lodging?.state,
            },
            fullAddressInfo: data?.lodging?.address_info,
            addressUrl: data?.lodging?.place_url,
          },
        }
      }}
      customBottomLeftItems={
        [
          // {
          //   header: 'Provider Number',
          //   text: data?.hospital?.provider_number || 'Not available',
          // },
          // {
          //   header: 'Hospital Beds',
          //   text: formatInteger(data?.hospital?.total_hospital_beds),
          // },
          // {
          //   header: 'Hospital Days',
          //   text: formatInteger(data?.hospital?.total_hospital_days),
          // },
          // {
          //   header: 'Cafeteria Expenditures',
          //   text: data?.hospital?.cafeteria
          //     ? formatUsd(parseInt(data?.hospital?.cafeteria))
          //     : 'N/A',
          // },
          // {
          //   header: 'Patient Meal Expenditures',
          //   text:
          //     // convert to integer and format
          //     data?.hospital?.dietary
          //       ? formatUsd(parseInt(data?.hospital?.dietary))
          //       : 'N/A',
          // },
          // {
          //   header: 'Contracted Patient Meal Expenditures',
          //   text: data?.hospital?.dietary_under_contract
          //     ? formatUsd(parseInt(data?.hospital?.dietary_under_contract))
          //     : 'N/A',
          // },
        ]
      }
    />
  )
}
